import { __assign } from "tslib";
import React, { useState } from 'react';
import { StepperFooter, StepperContent, ProgressHeader, IndicatorHeader } from '..';
var headers = {
    indicator: IndicatorHeader,
    progress: ProgressHeader,
};
/**
 * The `Stepper` is intended to guide a user through a multiple-step process.
 *
 * * The `type` property allow you to specify the `Stepper` you wish to render. We prefer to use `indicator`, also the default, on Desktop and `progress` for Mobile layouts.
 *
 * * The `footer` property allows for a multitude of styling, layout, and functional configurations by accepting a custom component.
 * If the property is undefined, the default footer will be rendered in its place.
 *
 * * The `steps` property accepts an array of items (see props table below for more detail) that can optionally specify a `stepAction` property. If specified, the `stepAction` will be executed before
 * advancing to the next step. This could include anything from submitting form data, dispatching an alert, or displaying a confirmation modal.
 *
 */
export var Stepper = function (_a) {
    var startingStep = _a.startingStep, steps = _a.steps, footer = _a.footer, type = _a.type, className = _a.className;
    var _b = useState(startingStep || 0), activeStep = _b[0], setActiveStep = _b[1];
    // We need to make sure we only render the conponent when the activeStep exists in the array of steps.
    // This prevents a re-render on the final step
    if (!steps[activeStep])
        return null;
    var handleNext = function () {
        if (steps[activeStep].stepAction)
            steps[activeStep].stepAction();
        steps[activeStep].completed = true;
        setActiveStep(function (prevActiveStep) { return prevActiveStep + 1; });
    };
    var handleBack = function () { return setActiveStep(function (prevActiveStep) { return prevActiveStep - 1; }); };
    var StepperHeader = headers[type];
    return (React.createElement("div", { className: "d-flex h-100 flex-column " + className },
        React.createElement(StepperHeader, __assign({}, { steps: steps, activeStep: activeStep })),
        React.createElement(StepperContent, { className: "d-flex flex-grow-1 my-3 mx-2" }, steps[activeStep].stepContent),
        React.createElement(StepperFooter, __assign({}, { steps: steps, footer: footer, activeStep: activeStep, handleBack: handleBack, handleNext: handleNext }, { backButtonText: "Back", nextButtonText: steps[activeStep].nextButtonText || 'Next' }))));
};
Stepper.defaultProps = {
    type: 'indicator',
    className: '',
};
export default Stepper;
//# sourceMappingURL=Stepper.js.map


// WEBPACK FOOTER //
// ../../../src/components/stepper/Stepper.tsx